import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Divider from 'components/Divider';
import Modal, { ModalHeader, ModalBody, ModalFooter } from 'components/Modal';

import './style.scss';

const UnsavedChangesModal = ({ onCancel, onDiscard, isOpen }) => (
  <Modal isOpen={isOpen}>
    <ModalHeader
      icon={<span className="icon-notification-warning" />}
      styleName="modal-header"
      title="Discard Changes?"
    />

    <Divider />

    <ModalBody styleName="modal-body">
      <strong>Notice: </strong>
      Leaving this page, any changes you have made, will be lost. Are you sure
      you want to discard these changes?
    </ModalBody>

    <ModalFooter justifyContent="flex-end">
      <Button
        isTransparent
        data-action="cancel"
        data-test="not-save-button"
        styleName="button"
        onClick={onCancel}
      >
        Cancel
      </Button>

      <div>
        <Button
          data-action="discard"
          data-test="cancel-button"
          styleName="button"
          onClick={onDiscard}
        >
          Discard
        </Button>
      </div>
    </ModalFooter>
  </Modal>
);

UnsavedChangesModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};

export default UnsavedChangesModal;
